export default __webpack_public_path__ + "static/media/Line.09195c22.svg";